import React from 'react'
import Router from 'next/router';
import { ModalInfo } from './UIComponents/Components/ModalInfo'
import { Modal, message, Icon } from "antd";
import HostConfig from "$ACTIONS/Host.config";
const BFFSCApi = HostConfig.Config.BffscHostApi;
import { APISETS } from "$ACTIONS/TLCAPI";
import { get, post } from "$ACTIONS/TlcRequest";
const apis = APISETS.slice(1)
import RecordFilter from './UIComponents/Components/WebComponents/RecordFilter'
import SpinLoading from './UIComponents/Components/WebComponents/SpinLoading'
import FeedBackSelect from './UIComponents/Components/WebComponents/FeedBackSelect'
import ReactCaptcha from '@/Captcha'

let GLOBAL = global || window

export default function RenderConfig() {
    return {
        Language: 'M3',
        locale: 'vn',
        platform: 'Web',
        GLOBAL: global || window,
        userName: Boolean(global?.localStorage?.getItem('access_token')) ? JSON?.parse(global?.localStorage?.getItem('memberInfo'))?.userName : '',
        format: 'YYYY/MM/DD HH:mm:ss',
        SpinLoading: (props) => {
            return <SpinLoading {...props}></SpinLoading>
        },
        RecordFilter: (props) => {
            return <RecordFilter {...props}></RecordFilter>
        },
        OpenLiveChat: ({ type = 'closeOut', listingParams = '', piwikStatus = '' }) => {
            GLOBAL?.PopUpLiveChat(listingParams)

            if (listingParams == '') {
                GLOBAL.Pushgtagpiwikurl('help_center', 'Help Center')
                GLOBAL.Pushgtagdata('HelpCenter', 'Contact CS', 'HelpCenter_C_CS'
                    // [
                    //     {
                    //         customVariableKey: "HelpCenter_C_CS_PageTitle",
                    //         customVariableValue: caseCategory
                    //     }
                    // ]
                )
            } else {
                const params = new URLSearchParams(listingParams);
                const caseCategory = decodeURIComponent(params.get('CUSTOM!CaseCategory'));
                GLOBAL.Pushgtagpiwikurl('help_center_feedback_record', 'Help Center Feedback Record')
                GLOBAL.Pushgtagdata('HelpCenter', 'Contact CS', 'HelpCenter_Record_C_FeedbackCS', false,
                    [
                        {
                            customVariableKey: "HelpCenter_Record_C_FeedbackCS_Status&Category",
                            customVariableValue: `${caseCategory},${piwikStatus}`
                        }
                    ]
                )
            }

        },
        Router: (params) => {
            let { routerName } = params
            if (routerName == 'pop') {
                global?.history.back()
                return
            }
            if (routerName == 'Login') {
                global?.goUserSign("1");
                Router.push('/customer-service/?type=history')
                return
            }
        },
        getRouterType: () => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const type = urlParams.get('type');
            return type
        },
        ApiGet: (url) => {
            let host = BFFSCApi
            return get(host + url + apis);
        },
        ApiPost: (url, postdata = '') => {
            let host = BFFSCApi
            return post(host + url + apis, postdata);
        },
        isUserLogin: Boolean(global?.localStorage?.getItem('access_token')),
        FeedBackTag: ({ children, tempText, onLeft, className }) => {
            return <Modal
                title={tempText?.text8}
                closeIcon={
                    <Icon type="close" style={{ fontSize: "18px" }} />
                }
                className={`modal-pubilc ${className}`}
                onCancel={() => {
                    onLeft('Feedback')
                }}
                visible={true}
                centered={true}
                width={420}
                footer={null}
                maskClosable={false}>
                {children}
            </Modal>
        },
        FeedBackSelect: (props) => {
            return <FeedBackSelect {...props}></FeedBackSelect>
        },
        FeedBackUpload: (props) => {
            return <>{props.children}</>
        },
        ReactCaptcha: (props) => {
            return <ReactCaptcha {...props}></ReactCaptcha>
        },
        Pushgtagpiwikurl: (url = '', title = '') => {
            GLOBAL.Pushgtagpiwikurl(url, title)
        },
        Pushgtagdata: (eventCategory = '', action = '', name = '', evtValue = false, aryCustomVariable = []) => {
            GLOBAL.Pushgtagdata(eventCategory, action, name, evtValue, aryCustomVariable)
        },
        ModalTip: {
            Info: (data) => {//1
                let {
                    title = '',
                    children = '',
                    isShowCloseBtn = false,
                    noBtnTxt = '',
                    noFunction = () => { },
                    okBtnTxt = '',
                    okFunction = () => { },
                } = data


                let className1 = title ? '' : 'CustomerServiceModalNoheader'
                let className2 = okBtnTxt ? '' : 'CustomerServiceModalNoFooter'


                Modal.info({
                    className: `confirm-modal-of-public ${className1} ${className2} CustomerServiceModal`,
                    icon: <></>,
                    title: title,
                    centered: true,
                    okText: okBtnTxt,
                    closable: true,
                    zIndex: 2000,
                    content: (
                        <div className="inline-link-btn CustomerServiceModalContainer">
                            {children}
                        </div>
                    ),
                    onOk: () => {
                        okFunction()
                    }
                });
            },
            Confirm: (data) => {//2
                let {
                    title = '',
                    children = '',
                    isShowCloseBtn = false,
                    noBtnTxt = '',
                    noFunction = () => { },
                    okBtnTxt = '',
                    okFunction = () => { },
                } = data

                let className1 = title ? '' : 'CustomerServiceModalNoheader'
                let className2 = okBtnTxt ? '' : 'CustomerServiceModalNoFooter'

                let ModalConfirm = Modal.confirm({
                    title: title,
                    width: 400,
                    icon: <div />,
                    centered: true,
                    className: `confirm-modal-of-public ${className1} ${className2} CustomerServiceModal`,
                    content: (
                        <div className="inline-link-btn CustomerServiceModalContainer">
                            {children}
                        </div>
                    ),
                    okText: okBtnTxt,
                    cancelText: noBtnTxt,
                    okButtonProps: {
                        type: "primary",
                        shape: "round",
                        style: { width: "46%" },
                        onClick: () => {
                            okFunction()

                            ModalConfirm.destroy()
                        },
                    },
                    cancelButtonProps: {
                        ghost: true,
                        type: "danger",
                        shape: "round",
                        onClick: () => {
                            noFunction()
                            ModalConfirm.destroy()
                        },
                    },
                });
            },
            close: () => {
                Modal.destroyAll()
            },
            ModalInfo: ({ text1 = '', text2 = '' }) => {
                let className = 'CustomerServiceModalNoheader'
                Modal.info({
                    className: `confirm-modal-of-public ${className} CustomerServiceModal`,
                    icon: <></>,
                    title: '',
                    centered: true,
                    okText: text2,
                    closable: true,
                    zIndex: 2000,
                    content: <div className="inline-link-btn CustomerServiceModalContainer">
                        {ModalInfo(text1)}
                    </div>,
                });
            }
        },
        ToastTip: {
            loading: () => {
                document.getElementById('CustomerServiceSpin')?.classList.add('show')
                document.getElementById('CustomerServiceSpin')?.classList.remove('hide')

                document.getElementById('CustomerServiceSpin')?.classList.add('show')
                document.getElementById('CustomerServiceSpin')?.classList.remove('hide')
            },
            hide: () => {
                document.getElementById('CustomerServiceSpin')?.classList.add('hide')
                document.getElementById('CustomerServiceSpin')?.classList.remove('show')

                document.getElementById('CustomerServiceSpin')?.classList.add('hide')
                document.getElementById('CustomerServiceSpin')?.classList.remove('show')
            },
            success: (msg) => { message.success(msg) },
            error: (msg) => { message.info(msg, 1.5) },
        },


        getImageSize: (url) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = function () {
                    // 图片加载完成后，解析 Promise 并返回图片的宽度和高度
                    resolve({ width: this.width, height: this.height });
                };
                img.onerror = function () {
                    // 图片加载失败，拒绝 Promise
                    reject(new Error("无法加载图片"));
                };
                img.src = url;
            });
        }
    }
}